import { useParams } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { Container, Row, Col, Button, Breadcrumb } from 'react-bootstrap'

import TextElement from '../elements/TextElement'
import CarouselElement from '../elements/CarouselElement'

import apiService from '../services/ApiService'

import { FaWhatsapp } from "react-icons/fa"

function NoticiasConteudo() {
  const { slug } = useParams()

  const [post, setPost] = useState(null)
  const [loading, setLoading] = useState(true)

  const processImages = (imagesData) => {
    if (!imagesData) return []
    
    try {
      if (typeof imagesData === 'object' && !Array.isArray(imagesData)) {
        return Object.values(imagesData)
      }

      if (Array.isArray(imagesData)) {
        return imagesData
      }

      const parsed = JSON.parse(imagesData)
      return Object.values(parsed)
    } catch (error) {
      console.error('Erro ao processar images:', error)
      return []
    }
  }

  useEffect(() => {
    const fetchPosts = async () => {
      setLoading(true)
      const websiteId = Number.parseInt(process.env.REACT_APP_WEBSITE_ID, 10)
      const fetchedPost = await apiService.getPostBySlug(websiteId, slug)

      if (!fetchedPost) {
        setLoading(false)
        return
      }

      const processedPost = {
        ...fetchedPost,
        images: processImages(fetchedPost.images)
      }

      // console.log('Fetched post:', processedPost)
      // console.log('Fetched post:', processedPost.text)
      
      setPost(processedPost)
      setLoading(false)
    }
    fetchPosts()
  }, [slug])

  const domain = window.location.hostname.replace('www.', '')

  const textoCompartilhamento = post ? `${post.title} - Leia mais em: https://${domain}/noticias/${post.slug}` : ''
  const urlWhatsapp = `https://wa.me/?text=${encodeURIComponent(textoCompartilhamento)}`

  if (loading || !post) {
    return (
      <Row className="align-items-center" style={{ marginTop: '50px', marginBottom: '50px' }}>
        <Col className="text-center">
          <p>Carregando...</p>
        </Col>
      </Row>
    )
  }

  return (
    <Container>
      <Row className="align-items-center" style={{ marginTop: '50px', marginBottom: '50px' }}>
        <Col>
          <Breadcrumb>
            <Breadcrumb.Item href="/noticias">
              NOTÍCIAS
            </Breadcrumb.Item>
            <Breadcrumb.Item active>{post.title}</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col xs={12} sm={12} md={12} lg={12}>
          <h1>{post.title}</h1>
        </Col>
        <Row className="align-items-center" style={{ width: '100%', marginBottom: '15px' }}>
          <Col xs={12} sm={12} md={9} lg={9} className='texto-cor-primaria' style={{ display: 'none' }}>
            {post.text}
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            <Button
              variant='success'
              href={urlWhatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex align-items-center justify-content-center"
              style={{ float: 'right', gap: '8px' }}
            >
              <FaWhatsapp /> ENVIAR POR WHATSAPP
            </Button>
          </Col>
        </Row>
        <Col xs={12} sm={12} md={12} lg={12} style={{ marginTop: '20px' }}>
          <TextElement data={post} />
        </Col>
        <Col xs={12} sm={12} md={12} lg={12} style={{ marginTop: '20px' }}>
          <CarouselElement data={post} />
        </Col>
      </Row>
    </Container>
  )
}

export default NoticiasConteudo
